import { useRef, useState, useEffect } from "react";
import { Volume2, Loader2, Square } from "lucide-react";
import { synthSpeech, audioUrl } from "@/lib/api";

export const SpeakButton = ({ text, voice = "sage", label, testid = "speak-btn", autoPlay = false }) => {
  const audioRef = useRef(null);
  const [url, setUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [playing, setPlaying] = useState(false);
  const autoTriedRef = useRef(false);

  const toggle = async () => {
    if (playing && audioRef.current) {
      audioRef.current.pause();
      return;
    }
    if (url && audioRef.current) {
      audioRef.current.play();
      return;
    }
    setLoading(true);
    try {
      const res = await synthSpeech(text, voice);
      const full = audioUrl(res.url);
      setUrl(full);
      setTimeout(() => audioRef.current && audioRef.current.play().catch(() => {}), 100);
    } catch {
      /* budget banner handled globally */
    } finally {
      setLoading(false);
    }
  };

  // Auto-play once (respects browser autoplay gestures — falls back gracefully if blocked)
  useEffect(() => {
    if (!autoPlay || autoTriedRef.current || !text) return;
    autoTriedRef.current = true;
    toggle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoPlay, text]);

  return (
    <>
      <audio
        ref={audioRef}
        src={url || undefined}
        onPlay={() => setPlaying(true)}
        onPause={() => setPlaying(false)}
        onEnded={() => setPlaying(false)}
      />
      <button
        data-testid={testid}
        onClick={toggle}
        className="inline-flex items-center gap-1.5 rounded-full border border-border px-2.5 py-1 text-xs font-semibold text-muted-foreground hover:text-foreground hover:border-primary/50 transition"
      >
        {loading ? (
          <Loader2 className="h-3.5 w-3.5 animate-spin" />
        ) : playing ? (
          <Square className="h-3.5 w-3.5" />
        ) : (
          <Volume2 className="h-3.5 w-3.5" />
        )}
        {label && <span>{playing ? "Stop" : label}</span>}
      </button>
    </>
  );
};
